import { Dispatcher } from 'flux';

const AppDispatcher = new Dispatcher();

export default AppDispatcher;



// WEBPACK FOOTER //
// ./ui_src/app/utils/AppDispatcher.jsx